import { Box, Typography } from '@mui/material';
import React from 'react';
import ActionableNodeTitleIcon from './ActionableNodeTitleIcon';
import ActionableNodeTitleMenu from './ActionableNodeTitleMenu';

type Props = {
	color: string;
	title: string;
	taskType: string;
	onEditClick: () => void;
	onDeleteClick: () => void;
};

const ActionableNodeTitle = ({
	color,
	title,
	onEditClick,
	onDeleteClick,
	taskType
}: Props) => (
	<Box
		display="flex"
		flexDirection="row"
		alignItems="center"
		justifyContent="flex-start"
	>
		<ActionableNodeTitleIcon color={color} taskType={taskType} />
		<Typography variant="body1" fontWeight={800} color="text.primary" pl={1}>
			{title}
		</Typography>
		<ActionableNodeTitleMenu
			onEditClick={onEditClick}
			onDeleteClick={onDeleteClick}
		/>
	</Box>
);

export default ActionableNodeTitle;
